import { create } from 'zustand';

import type { LocationId } from '@brightlocal/shared';

/**
 * In-memory draft carried from the keywords step to the prompts step.
 */
interface AddLocationDraftState {
  /** Location the draft keywords belong to, or `null` when empty. */
  locationId: LocationId | null;
  /** Keywords saved on the keywords step, ready for the prompts step. */
  keywords: string[];
  /** Saves the location and its keywords so the prompts step can pick them up. */
  setDraft: (locationId: LocationId, keywords: string[]) => void;
  /** Clears the draft. */
  reset: VoidFunction;
}

const initialState = {
  locationId: null,
  keywords: []
};

/**
 * Holds keywords between the Add Location keywords and prompts steps.
 * In-memory only — a refresh on prompts sends the user back to keywords.
 */
export const useAddLocationDraftStore = create<AddLocationDraftState>((set) => ({
  ...initialState,
  setDraft: (locationId, keywords) => set({ locationId, keywords }),
  reset: () => set(initialState)
}));
